<button *ngFor="let aParam of extProfilesService.getParams(keyname)"
        mat-stroked-button
        class="mb-2 whitespace-pre-wrap"
        [ngClass]="{'text-white	bg-green-inbe': cUser?.extProfiles?.[keyname]===aParam.key }"
        (click)="setExt(aParam.key)">
    {{aParam.label|translateLabel: translocoService.getActiveLang() }}
</button>
<p *ngIf="displayDebug">generic-uniq : {{keyname|json}}</p>
